import classNames from 'classnames';
import CustomButton from '../../../../features/customButton/ui/main/CustomButton';
import StatusPanel from '../../../../baseComponents/gui/statusPanel/StatusPanel';
import { CSSTransition } from 'react-transition-group';
import { useRequests } from '../../../../../redux/reducer/requests';
import { defaultStore } from '../../../../../translations';
import content from '../../constants/content';

const {
  statusPanel,
  buttons: { toFriends, toBack },
} = content;

export default function Header() {
  const { authData: { isWeb } = {} } = useRequests();

  return (
    <>
      <div className={classNames('interactive-shop__header', !isWeb && 'app')}>
        <div className={classNames(`interactive-shop__header-top`, `interactive-shop__header-top_${defaultStore}`)}>
          <CustomButton {...toFriends} />
          <StatusPanel {...statusPanel} />
          <span className={'interactive-shop__header-stub'} />
        </div>
      </div>
      <CSSTransition appear={true} in={true} timeout={300}>
        <div className={`interactive-shop__button`}>
          <CustomButton {...toBack} />
        </div>
      </CSSTransition>
    </>
  );
}
